export const TABLE_VIEW = Object.freeze({
    AUTO: 'AUTO',
    TABLE: 'TABLE',
    ACCORDION: 'ACCORDION'
});

export const DEFAULT_ACCORDION_VIEW_WIDTH_THRESHOLD = 640;
